import { LearningObject } from "../learningObject.model"

export class PremiumFeaturedSection {
    public constructor(
        public title: string,
        public description: string,
        public learningObjects: LearningObject[]
    ) {}

    public static fromData(data): PremiumFeaturedSection {
        return new PremiumFeaturedSection(
            data.title,
            data.description,
            (data.resources || []).map((lo_data) => new LearningObject(lo_data))
        )
    }
}
